function Graph() {
  return (
    <>
    <main class="flex-shrink-0">
      <div class="container">
        <h2 class="mt-5">Graph</h2>
        <p class="lead">
          Link to graph browser, download section for data, and tooling.
        </p>
      </div>
    </main>
    </>
  );
}

export default Graph;